import React from "react";
import { Slide } from "react-reveal";
import Services from "../reusables/Services";

const OurServices = () => {
  return (
    <section className="section section-spacing-100 dark-bg no-padding-bottom">
      <div className="large">
        <div className="section-content">
          <div className="width-600 margin-auto center">
            <p className="section-name boldTitle uppercase white">
              What We Offer
            </p>
            <Slide top>
              <div className="section-head">
                <h2 className="section-title red">Our Services</h2>

                <p className="section-subtitle margin-top-bottom-10 light-gray">
                  We’ve worked all types of events ranging from intimate dinners
                  parties to large corporate gatherings.
                </p>
              </div>
            </Slide>
          </div>
          <div className="section-body section-spacing-100">
            <Services />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
